import React from 'react';
import { Badge, type BadgeProps } from 'react-bootstrap-5';
import {
  faBan,
  faCheckToSlot,
  faFileMagnifyingGlass,
  faHandshake,
  faMemoCircleCheck,
  faMoneyFromBracket
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './styles.scss';
import classNames from 'classnames';
import type { Deal } from '../../types';

type StageBadgeProps = BadgeProps & {
  deal?: Deal;
  stage: string;
  stageLabel: string;
}

export default function StageBadge({ deal, stage, stageLabel, ...props }: StageBadgeProps) {
  let icon = faMemoCircleCheck;
  switch (stage ?? deal?.stage) {
  case 'sourcing':
    icon = faCheckToSlot;
    break;
  case 'evaluating':
    icon = faFileMagnifyingGlass;
    break;
  case 'transacting':
    icon = faMoneyFromBracket;
    break;
  case 'closed':
    icon = faHandshake;
    break;
  case 'dead':
    icon = faBan;
    break;
  }

  return (
    <Badge
      className={classNames('apex-deal-stage-badge', stage ?? deal?.stage, props.className)}
      text={stage}
      {...props}
    >
      <FontAwesomeIcon color="black" icon={icon} size="xs" />
      {stageLabel ?? deal?.stageLabel}
    </Badge>
  );
}
